import React, { createContext, useContext } from "react";
import PropTypes from "prop-types";
//Limitless imports
import { useMessageResponse } from "./ExpertMessageResponseHook";
// Set the default state values for each context
export const ExpertMessageResponseContext = /*#__PURE__*/createContext({});
export const ExpertMessageResponseContextProvider = ({
  children
}) => {
  const messageResponse = useMessageResponse();
  return /*#__PURE__*/React.createElement(ExpertMessageResponseContext.Provider, {
    value: messageResponse
  }, children);
};
export const useExpertMessageResponseContext = () => {
  return useContext(ExpertMessageResponseContext);
};
ExpertMessageResponseContextProvider.propTypes = {
  children: PropTypes.node.isRequired
};